import { Sparkles } from "lucide-react";
import type { FormData } from "../types";
import { validateFormData } from "../utils";
import { LessonInfoSection } from "../sections/LessonInfoSection";
import { LessonTypeSection } from "../sections/LessonTypeSection";
import { ObjectivesSection } from "../sections/ObjectivesSection";
import { SettingsSection } from "../sections/SettingsSection";
import { CustomInstructionsSection } from "../sections/CustomInstructionsSection";

interface FormStepProps {
  formData: FormData;
  subjects: string[];
  classes: string[];
  onFormChange: (field: keyof FormData, value: any) => void;
  onGenerate: () => void;
}

export function FormStep({
  formData,
  subjects,
  classes,
  onFormChange,
  onGenerate,
}: FormStepProps) {
  const handleGenerateClick = () => {
    const error = validateFormData(formData);
    if (error) {
      alert(error);
      return;
    }
    onGenerate();
  };

  return (
    <div className="space-y-6">
      <div className="grid md:grid-cols-2 gap-6 mb-6">
        <LessonInfoSection
          formData={formData}
          subjects={subjects}
          classes={classes}
          onFormChange={onFormChange}
        />
        <LessonTypeSection formData={formData} onFormChange={onFormChange} />
        <ObjectivesSection formData={formData} onFormChange={onFormChange} />
        <SettingsSection formData={formData} onFormChange={onFormChange} />
        <CustomInstructionsSection
          formData={formData}
          onFormChange={onFormChange}
        />
      </div>

      <div className="flex justify-end">
        <button
          onClick={handleGenerateClick}
          disabled={!formData.subject || !formData.grade || !formData.topic}
          className="flex items-center gap-3 px-6 py-3 rounded-xl text-white font-medium transition hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
          style={{ backgroundColor: "#1967d2" }}
        >
          <Sparkles className="w-5 h-5" />
          Gerar Plano de Aula com IA
        </button>
      </div>
    </div>
  );
}
